export const calculateIndexAdjustment = (tenant, unit, property, vpiData) => {
  const currentRent = parseFloat(tenant.monthly_rent) || 0;
  
  if (!unit || !property) return null;
  
  // Get area from size_sqm (correct field) with proper fallback
  const unitArea = unit.size_sqm || unit.size;
  if (!unitArea) {
    console.warn('⚠️ No area data available for unit:', unit.id);
  }

  // VPI calculation using real API data
  let vpiIncrease = 0;
  let baseIndex = null;
  let currentIndex = null;
  let baseDate = null;
  let currentDate = null;
  let isEstimated = false;
  let serviceAvailable = false;

  if (vpiData && vpiData.historicalData && vpiData.historicalData.length > 0) {
    serviceAvailable = true;
    try {
      baseDate = tenant.base_rent_date || tenant.lease_start;
      const baseDateObj = new Date(baseDate);
      
      // Find base index from historical data
      const baseEntry = vpiData.historicalData.find(entry => {
        const entryDate = new Date(entry.period + '-01');
        return entryDate.getFullYear() === baseDateObj.getFullYear() &&
               entryDate.getMonth() === baseDateObj.getMonth();
      });
      
      // Get current index (latest available)
      const currentEntry = vpiData.historicalData[0]; // Always use newest entry (array is sorted descending)
      
      if (baseEntry && currentEntry) {
        baseIndex = parseFloat(baseEntry.index_value);
        currentIndex = parseFloat(currentEntry.index_value);
        currentDate = currentEntry.period;
        vpiIncrease = ((currentIndex - baseIndex) / baseIndex) * 100;
      } else {
        isEstimated = true;
        // Fallback to estimation if data not found
        const lastAdjustmentDate = tenant.last_lease_adjustment ? new Date(tenant.last_lease_adjustment) : new Date(tenant.lease_start);
        const monthsSinceAdjustment = (new Date() - lastAdjustmentDate) / (1000 * 60 * 60 * 24 * 30);
        vpiIncrease = Math.min(monthsSinceAdjustment * 0.2, 15);
      }
    } catch (error) {
      console.error('❌ VPI calculation error:', error);
      isEstimated = true;
      // Fallback to estimation
      const lastAdjustmentDate = tenant.last_lease_adjustment ? new Date(tenant.last_lease_adjustment) : new Date(tenant.lease_start);
      const monthsSinceAdjustment = (new Date() - lastAdjustmentDate) / (1000 * 60 * 60 * 24 * 30);
      vpiIncrease = Math.min(monthsSinceAdjustment * 0.2, 15);
    }
  } else {
    isEstimated = true;
    // No VPI data available, use estimation
    const lastAdjustmentDate = tenant.last_lease_adjustment ? new Date(tenant.last_lease_adjustment) : new Date(tenant.lease_start);
    const monthsSinceAdjustment = (new Date() - lastAdjustmentDate) / (1000 * 60 * 60 * 24 * 30);
    vpiIncrease = Math.min(monthsSinceAdjustment * 0.2, 15);
  }

  const amount = currentRent * (vpiIncrease / 100);
  const newRent = currentRent + amount;
  const thresholdPercentage = tenant.threshold_percentage || 3;
  const thresholdMet = vpiIncrease >= thresholdPercentage;

  return {
    currentRent,
    area: unitArea,
    vpi: {
      serviceAvailable,
      isEstimated,
      baseDate,
      currentDate,
      baseIndex,
      currentIndex,
      percentage: vpiIncrease,
      amount: amount,
      newRent: newRent,
      thresholdPercentage,
      thresholdMet
    }
  };
};
